import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { PAGE_CONTENT_CLASS } from '../../components/layout/PageContent';
import PageHeader from '../../components/PageHeader';
import { listUserTemplates } from '../../services/templateService';
import { FavoriteModelsProvider } from '../../context/FavoriteModelsContext';
import SystemModelsCard from './components/SystemModelsCard';
import UserModelsCard from './components/UserModelsCard';
import FavoritesCard from './components/FavoritesCard';

const ModelLibraryPage = () => {
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(true);

  const loadTemplates = useCallback(async () => {
    setTemplatesLoading(true);
    try {
      const result = await listUserTemplates();
      if (result.success) {
        setTemplates(result.data?.items ?? []);
      } else {
        setTemplates([]);
      }
    } catch (_error) {
      setTemplates([]);
    } finally {
      setTemplatesLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTemplates();
  }, [loadTemplates]);

  return (
    <>
      <Helmet>
        <title>Biblioteca de Modelos</title>
        <meta
          name="description"
          content="Acesse modelos do sistema, personalizados e favoritos"
        />
      </Helmet>

      <div className={PAGE_CONTENT_CLASS}>
        <PageHeader
          title="Biblioteca de Modelos"
          subtitle="Modelos do sistema, personalizados e favoritos para gerar documentos"
          icon="Library"
          className="mb-4 md:mb-6"
        />

        <FavoriteModelsProvider>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-5 items-stretch max-w-6xl">
            <SystemModelsCard />
            <UserModelsCard
              templates={templates}
              isLoading={templatesLoading}
            />
            <FavoritesCard
              userTemplates={templates}
              templatesLoading={templatesLoading}
            />
          </div>
        </FavoriteModelsProvider>
      </div>
    </>
  );
};

export default ModelLibraryPage;
